<li class="w-60">
  <div class="font-semibold mb-3 h-6 flex items-center gap-2">
    <span>Saúde</span>
    <div
      class="font-semibold rounded-2xl py-1 px-2 border flex items-center gap-2 bg-[#F3F4F6]"
    >
      <ng-icon name="heroSparklesMini" size="20px" color="#f59e0b"></ng-icon>
      <span>Novo</span>
    </div>
  </div>
  <ul>
    @if (isTrialExpirado) {
      <menu-item-saude-trial-expirado></menu-item-saude-trial-expirado>
    } @else {
      <menu-item-saude-trial></menu-item-saude-trial>
    }
  </ul>
</li>
